// export default function (element, data) {
//     let scrollPos = window.scrollY;

//     if (window.innerWidth < 992) {
//         element.classList.add("active");
//     } else {
//         if (scrollPos > 30) {
//             element.classList.add("active");
//         } else {
//             element.classList.remove("active");
//         }
        
//         window.addEventListener('scroll', () => {
//             scrollPos = window.scrollY
    
//             if (scrollPos > 30) {
//                 element.classList.add("active");
//             } else {
//                 element.classList.remove("active");
//             }
//         }, {
//             passive: true
//         });
//     }
// };
export default function headerSticky(element, data) {

    let stickyEl = document.querySelector('.page-header');
    let stickyElHeight = stickyEl?.offsetHeight;

    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {       
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let top = stickyEl.offsetHeight * (-1) + "px";

        if (scrollTop > lastScrollTop) {
            stickyEl.style.top = top;
        } else {
            stickyEl.style.top = window.innerWidth < 768 ? 0 : "10px";
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
};